import { Market } from '@event/types/event';
import { api } from '@services/api';

const marketsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getMarkets: builder.query<Market[], void>({
            query: () => 'public/markets/',
            providesTags: ['Markets'],
        }),
    }),
});

export const { useGetMarketsQuery } = marketsApi;
export default marketsApi;
